
export default {
    onlineUsers: [],
};